import {
  API_GET_TRANSACTIONS_LIST,
  API_CREATE_TRANSACTION,
  API_GET_WITHDRAWAL,
  API_CHANGE_TRANSACTION_STATUS,
  API_GET_SUMMARY_WITHDRAWAL,
  API_GET_DEAL_PAYMENTS,
  API_CREATE_DEAL_PAYMENT,
  API_EDIT_TRANSACTION,
  API_APPLY_COMMISSION,
  API_APPLY_PSF,
  API_GET_LEVERAGE_AMOUNT,
  API_GET_SUMMARY_REJECTED,
  API_GET_REJECTED,
  API_RESOLVE_DEAL_PAYMENT,
  API_RESOLVE_DEAL_PAYMENTS,
  API_GET_COMMISSIONS_SUMMARY,
  API_DELETE_TRANSACTION,
} from 'constants/apiUrl'
import { privateInstance } from 'services/axios/privateInstance'
import {
  ITransactionListParams,
  ITransactionListRequest,
  ITransactionParamsInitValue,
  ICreateTransactionResponse,
  IWithdrawalGetParams,
  ITransactionChangeStatusValues,
  IWithdrawalListItem,
  IWithdrawalGetSummaryItem,
  IGetDealPaymentsParams,
  IDealPayment,
  IEditTransactionParams,
  IRejectedSummary,
  IRejectedListItem,
  ITotalCommissionSummaryItem,
} from 'typescript/interfaces/transactions'
import { AxiosResponse } from 'axios'
import { AdditionalRejectedPaginationProps, IDealPaymentParams, IDealPaymentResolveParams } from 'typescript/interfaces/deals'
import { generatePath } from 'react-router-dom'
import { IPagination } from 'typescript/interfaces/pagination'
import { SortFieldsRejected } from 'typescript/enums/transactions'

export const transformRequestOptions = (params: any) => {
  let options = ''
  for (const key in params) {
    if (typeof params[key] !== 'object' && (params[key] || params[key] === 0)) {
      options += `${key}=${params[key]}&`
    } else if (typeof params[key] === 'object' && (params[key] || params[key] === 0) && params[key].length) {
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      params[key].forEach((el) => {
        options += `${key}=${el}&`
      })
    }
  }
  return options ? options.slice(0, -1) : options
}


export const getTransactionList = (params: ITransactionListParams) =>
  privateInstance.get<ITransactionListParams, AxiosResponse<ITransactionListRequest>>(API_GET_TRANSACTIONS_LIST, {
    params: params,
  })

export const getLeverage = (userPageId: string) =>
  privateInstance.get<string, AxiosResponse<number>>(API_GET_LEVERAGE_AMOUNT, {
    params: { userPageId },
  })

export const createTransaction = (values: Partial<ITransactionParamsInitValue>) =>
  privateInstance.post<Partial<ITransactionParamsInitValue>, AxiosResponse<ICreateTransactionResponse>>(API_CREATE_TRANSACTION, values)

export const getWithdrawal = (params: IWithdrawalGetParams) =>
  privateInstance.get<IWithdrawalGetParams, AxiosResponse<Array<IWithdrawalListItem>>>(API_GET_WITHDRAWAL, {
    params: params,
  })

export const getRejected = (params: IPagination<SortFieldsRejected> & AdditionalRejectedPaginationProps) =>
  privateInstance.get<IPagination<SortFieldsRejected>, AxiosResponse<Array<IRejectedListItem>>>(API_GET_REJECTED, {
    params: params,
    paramsSerializer: transformRequestOptions,
  })

export const changeStatus = (values: ITransactionChangeStatusValues) =>
  privateInstance.put<ITransactionChangeStatusValues, AxiosResponse<boolean>>(API_CHANGE_TRANSACTION_STATUS, values)

export const getSummaryWithdrawal = () => privateInstance.get<any, AxiosResponse<IWithdrawalGetSummaryItem[]>>(API_GET_SUMMARY_WITHDRAWAL)

export const getTotalCommissions = (userPageId: string) =>
  privateInstance.get<any, AxiosResponse<ITotalCommissionSummaryItem>>(
    generatePath(API_GET_COMMISSIONS_SUMMARY, {
      userPageId: userPageId,
    }),
  )
export const getSummaryRejected = (params: IPagination<SortFieldsRejected> & AdditionalRejectedPaginationProps) =>
  privateInstance.get<IPagination<SortFieldsRejected>, AxiosResponse<IRejectedSummary>>(API_GET_SUMMARY_REJECTED, {
    params: params,
    paramsSerializer: transformRequestOptions,
  })

export const getDealPayments = (params: IGetDealPaymentsParams) =>
  privateInstance.get<IGetDealPaymentsParams, AxiosResponse<IDealPayment[]>>(API_GET_DEAL_PAYMENTS, {
    params: params,
  })

export const createDealPayment = (params: IDealPaymentParams) =>
  privateInstance.post<IDealPaymentParams, AxiosResponse<boolean>>(API_CREATE_DEAL_PAYMENT, params)

export const resolveDealPayment = (params: IDealPaymentResolveParams) =>
  privateInstance.post<IDealPaymentParams, AxiosResponse<boolean>>(API_RESOLVE_DEAL_PAYMENT, params)

export const resolveDealPayments = (params: IDealPaymentParams) =>
  privateInstance.post<IDealPaymentParams, AxiosResponse<boolean>>(API_RESOLVE_DEAL_PAYMENTS, params)

export const editTransaction = (params: IEditTransactionParams) =>
  privateInstance.put<IEditTransactionParams, AxiosResponse<boolean>>(API_EDIT_TRANSACTION, params)

export const applyCommission = (id: string | number) =>
  privateInstance.post<typeof id, AxiosResponse<boolean>>(
    generatePath(API_APPLY_COMMISSION, {
      id: id,
    }),
  )

export const applyPsf = (id: string | number) =>
  privateInstance.post<typeof id, AxiosResponse<boolean>>(
    generatePath(API_APPLY_PSF, {
      id: id,
    }),
  )

export const deleteTransaction = (id: string | number) =>
  privateInstance.delete<typeof id, AxiosResponse<null>>(
    generatePath(API_DELETE_TRANSACTION, {
      id: id,
    }),
  )
